
export default function OverviewBadges() {
  const badges = [
    { icon: 'ri-time-line', label: '所要時間', value: '約10分', color: 'from-teal-500 to-emerald-500' },
    { icon: 'ri-money-yen-circle-line', label: '費用', value: '完全無料', color: 'from-emerald-500 to-green-500' },
    { icon: 'ri-smartphone-line', label: '申込方法', value: 'スマホ完結', color: 'from-green-500 to-teal-500' },
    { icon: 'ri-flashlight-line', label: '審査', value: '最短即日', color: 'from-teal-600 to-emerald-600' },
  ];

  return (
    <section className="py-12 bg-white">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {badges.map((badge, i) => (
            <div key={i} className="relative bg-white rounded-xl border border-gray-100 p-5 text-center hover:shadow-lg transition-shadow group">
              <div className={`w-12 h-12 mx-auto mb-3 bg-gradient-to-br ${badge.color} rounded-xl flex items-center justify-center group-hover:scale-110 transition-transform`}>
                <i className={`${badge.icon} text-white text-xl`}></i>
              </div>
              <p className="text-xs text-gray-500 mb-1">{badge.label}</p>
              <p className="text-lg font-bold text-gray-900">{badge.value}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
